import styled from 'styled-components';
import {
  blackSphera,
  brandBlack,
  grayLightSphera,
  grayPlaceholder,
  greenSp,
  whiteSphera
} from 'src/utilities/UIStyles/variables/Colors';

export const CreditInformationContainer = styled.section`
  background-color: rgb(245, 245, 245);
  padding: 2.5%;
  @media (min-width: 600px) and (max-width: 1024px) {
    > button {
      background-color: ${blackSphera};
    }
  }

  @media (max-width: 600px) {
    padding-top: 25%;
    padding-bottom: 2.5%;

    > button {
      font-size: 2.5vw;
      margin: 5% 25%;
      padding: 1% 3%;
    }
  }
`;

export const Banner = styled.div`
  background-color: ${whiteSphera};
  padding: 2.5% 0;

  > div {
    display: flex;
    justify-content: left;
    align-items: center;
    width: 100%;
    margin: auto;
    padding-left: 12%;

    > figure {
      width: 60px;
      height: 60px;
      margin-right: 5%;

      > img {
        width: 100%;
        height: 100%;
      }
    }

    > h2 {
      color: ${blackSphera};
      font-size: 2vw;
      width: 30%;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > figure {
        > img {
        }
      }

      > h2 {
      }
    }
  }

  @media (max-width: 600px) {
    padding: 2.5% 0 2.5% 2.55%;

    > div {
      justify-content: center;
      flex-wrap: wrap;

      > figure {
        width: 120px;
        height: 120px;
        margin-right: 5%;

        > img {
        }
      }

      > h2 {
        font-size: 5vw;
        width: 100%;
        margin-right: 0;
        margin-bottom: 5%;
        text-align: center;
      }
    }
  }
`;

export const FormContainer = styled.div`
  width: 80%;
  margin: 2.5% auto;
  padding: 2.5%;
  background-color: ${whiteSphera};
  border-radius: 5px;
  -webkit-box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
  > div {
    > h4 {
      text-align: center;
      color: ${brandBlack};
      margin: 2% 0;
      > a {
        color: ${greenSp};
      }
    }
  }
  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    width: 95%;
    margin: 5% auto;
    padding: 5%;
  }
`;

export const FormData = styled.div`
  padding: 0 2%;
  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
  }
`;

export const FormDataTitle = styled.h2`
  font-size: 2vw;
  color: ${greenSp};
  margin-bottom: 2%;
  border-bottom: 1px solid ${grayLightSphera};
  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    font-size: 5vw;
    margin-bottom: 5%;
  }
`;

export const FormDataGeneral = styled.div`
  display: flex;
`;

export const FormDataInvoices = styled.div`
  margin-top: 2.5%;
  > div:nth-child(2) {
    display: flex;
    margin-bottom: 2.5%;
    > button:nth-child(1) {
      font-size: 1.2vw;
      font-weight: bold;
      color: ${blackSphera};
      margin-right: 5%;
      padding: 1% 6%;
      border: 1px solid ${blackSphera};
      border-radius: 5px;
      background-color: transparent;
      cursor: pointer;
    }
    > button:nth-child(2) {
      font-size: 1.2vw;
      font-weight: bold;
      color: ${whiteSphera};
      padding: 1% 6%;
      border: none;
      border-radius: 5px;
      background-color: ${blackSphera};
      cursor: pointer;
    }
  }

  > div:nth-child(2n + 3) {
    background-color: rgba(0, 0, 0, 0.03);
  }

  > div:nth-child(n + 3) {
    width: 95%;
    margin: auto;
    padding: 1%;

    > h2 {
      font-size: 2vw;
    }

    > div {
      display: flex;

      > div:nth-child(1) {
        margin-right: 15%;
      }

      > div {
        margin: 1% 0;

        > h3 {
          color: ${blackSphera};
          font-size: 1.2vw;
          margin-bottom: 1%;
        }

        > input {
          visibility: hidden;
          width: 0;
          padding: 0;
        }

        > label {
          display: inline-block;
          color: ${whiteSphera};
          font-size: 1.2vw;
          font-weight: bold;
          text-align: center;
          width: 200px;
          padding-top: 5%;
          padding-bottom: 5%;
          border-radius: 5px;
          background-color: ${blackSphera};
          cursor: pointer;
        }
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    margin-top: 2.5%;
    > div:nth-child(2) {
      flex-direction: column;
      > button:nth-child(1) {
        font-size: 4.2vw;
        width: 100%;
        margin-right: 0;
        margin-bottom: 2.5%;
        padding: 3%;
      }
      > button:nth-child(2) {
        font-size: 4.2vw;
        width: 100%;
        padding: 3%;
      }
    }
    > div:nth-child(2n + 3) {
    }
    > div:nth-child(n + 3) {
      > h2 {
        font-size: 5vw;
        margin-top: 10%;
      }
      > div {
        flex-direction: column;

        > div:nth-child(1) {
        }
        > div {
          > h3 {
            font-size: 4.2vw;
            margin-top: 5%;
          }
          > label {
            font-size: 4.2vw;
            width: 250px;
          }
        }
      }
    }
  }
`;

export const StyledButton = styled.button`
  background-color: ${(props) => (props.disabled ? grayLightSphera : blackSphera)};
  font-size: 1.2vw;
  color: ${whiteSphera};
  margin-left: 80%;
  border: none;
  border-radius: 5px;
  color: white;
  border: none;
  padding: 10px 15px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${(props) => (props.disabled ? grayLightSphera : blackSphera)};
  }
`;

export const SectionFields = styled.div`
  width: 50%;
  padding: 4% 0;
  /* background-color: lavender; */
  > div {
    margin: 3% 0;
    > p {
      color: ${blackSphera};
      font-size: 1.2vw;
      margin-top: 2.5%;
      margin-bottom: 1%;
    }
    > input {
      font-size: 1.2vw;
      color: ${grayPlaceholder};
      width: 80%;
      height: 35px;
      padding-left: 1%;
      border: 1px solid ${grayLightSphera};
      border-radius: 5px;
    }
    > select {
      color: ${grayPlaceholder};
      font-size: 1.2vw;
      width: 80%;
      height: 35px;
      padding-left: 1%;
      border: 1px solid ${grayLightSphera};
      border-radius: 5px;
    }
  }
`;
